// src/app/routes.tsx
import { type AnyRoute, createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { ComponentType } from "react";

type Loader = () => Promise<{ default: ComponentType }>;

/** مسارات صفحات التطبيق (خلف تسجيل الدخول). كل صفحة تُحمَّل كسولاً في حزمة مستقلة. */
export function appPages(parent: AnyRoute) {
  const page = (path: string, load: Loader) =>
    createRoute({ getParentRoute: () => parent, path, component: lazyRouteComponent(load) });

  return [
    page("/dashboard", () => import("@/features/dashboard/DashboardPage")),
    page("/projects", () => import("@/features/projects/ProjectsPage")),
    page("/projects/$projectId/units", () => import("@/features/units/UnitsPage")),
    page("/projects/$projectId/contracts", () => import("@/features/contracts/ContractsPage")),
    page("/projects/$projectId/contracts/$contractId", () => import("@/features/contracts/ContractDetailPage")),
    page("/accounting/accounts", () => import("@/features/accounting/AccountsPage")),
    page("/accounting/journal-entries", () => import("@/features/accounting/JournalPage")),
    page("/accounting/journal-entries/new", () => import("@/features/accounting/JournalEntryFormPage")),
    page("/accounting/disbursements", () => import("@/features/accounting/DisbursementsPage")),
    page("/accounting/disbursements/$disbursementId", () => import("@/features/accounting/DisbursementDetailPage")),
    page("/projects/$projectId/procurement", () => import("@/features/procurement/ProcurementPage")),
    page("/waqf", () => import("@/features/waqf/WaqfPage")),
    page("/waqf/$waqfId/payout-cycles", () => import("@/features/waqf/PayoutCyclesPage")),
    page("/waqf/$waqfId/payout-cycles/$cycleId", () => import("@/features/waqf/PayoutCycleDetailPage")),
    page("/beneficiary-portal", () => import("@/features/waqf/BeneficiaryPortalPage")),
    page("/projects/$projectId/inspections", () => import("@/features/maintenance/MaintenancePage")),
    page("/vendor/work-orders", () => import("@/features/vendor-portal/VendorWorkOrdersPage")),
    page("/projects/$projectId/assets", () => import("@/features/assets/AssetsPage")),
    page("/letters", () => import("@/features/letters/LettersPage")),
    page("/letters/$letterId", () => import("@/features/letters/LetterDetailPage")),
    page("/reports", () => import("@/features/static/ReportsPage")),
    page("/admin/risk-register", () => import("@/features/static/RisksPage")),
    page("/security", () => import("@/features/security/SecurityPage")),
    page("/platform", () => import("@/features/platform/OverviewPage")),
    page("/platform/r/$resource", () => import("@/features/platform/ResourcePage")),
    page("/platform/settings", () => import("@/features/platform/SettingsPage")),
    page("/platform/ai-providers", () => import("@/features/platform/AiProvidersPage")),
    page("/platform/ai-call-logs", () => import("@/features/platform/AiCallLogsPage")),
    page("/platform/secrets", () => import("@/features/platform/PlatformSecretsPage")),
    page("/kpis", () => import("@/features/admin/KpisPage")),
    page("/admin/integrations", () => import("@/features/admin/IntegrationsPage")),
  ];
}
